/**
 * Anchor Lightbox
 *
 * Intercepts clicks on links whose href matches a page lightbox anchor
 * (registered via the "Page Lightboxes" ACF repeater on the page), then
 * opens the existing FarloUiLightbox with the corresponding content.
 *
 * The PHP layer renders a hidden `.farlo-ui-lightbox__toggle--anchor` element
 * for each repeater row. The existing FarloUiLightbox init code picks these up
 * and creates instances for them. This module simply wires anchor links to those
 * hidden toggles so clicking `<a href="#my-anchor">` is equivalent to clicking
 * the hidden toggle whose data-anchor is "my-anchor".
 */
export function initAnchorLightboxes() {
	const anchorToggles = document.querySelectorAll('.farlo-ui-lightbox__toggle--anchor[data-anchor]');
	if (!anchorToggles.length) return;

	const anchorMap = {};
	anchorToggles.forEach((toggle) => {
		const anchor = toggle.dataset.anchor;
		if (anchor) {
			anchorMap[anchor] = toggle;
		}
	});

	document.querySelectorAll('a[href^="#"]').forEach((link) => {
		const href = link.getAttribute('href');
		if (!href || href === '#') return;

		const anchor = href.slice(1);
		if (!anchorMap[anchor]) return;

		link.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopImmediatePropagation();
			anchorMap[anchor].click();
		});
	});
}
